import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { buildModuleRoute, buildNavigation } from 'modules/core/lib/react-router'

import timeoffCalendarRoutes from 'modules/timeoff/routes/calendar'
import timeoffCalendarTeamsRoutes from 'modules/timeoff/routes/calendar_teams'

const BulkAddTimeOffModalPage = React.lazy(
  () => import('modules/calendar/pages/BulkAddTimeoffModalPage')
)

const CalendarPage = React.lazy(() => import('modules/calendar/pages/CalendarPage'))
const CalendarRootPage = React.lazy(() => import('modules/calendar/pages/CalendarRootPage'))
const TeamViewPage = React.lazy(() => import('modules/calendar/pages/TeamViewPage'))

export const calendarRoutes = buildNavigation((navigation) => [
  buildModuleRoute({
    path: navigation.calendar.path,
    element: <CalendarRootPage />,
    handle: {
      module: 'calendar',
      moduleName: () => i18n.t('calendar.title'),
      meta: () => ({
        title: i18n.t('calendar.title'),
        illustration: 'calendar',
        subNavigation: [
          {
            index: true,
            title: i18n.t('calendar.title'),
            href: navigation.calendar.calendar.fullPath(),
          },
          {
            title: i18n.t('calendar.team_view'),
            href: navigation.calendar.teamView.fullPath(),
          },
        ],
      }),
    },
    children: [
      {
        path: navigation.calendar.calendar.path,
        element: <CalendarPage />,
        children: timeoffCalendarRoutes(navigation),
        handle: {
          meta: () => ({
            title: i18n.t('calendar.title'),
          }),
        },
      },
      {
        path: navigation.calendar.teamView.path,
        element: <TeamViewPage />,
        children: timeoffCalendarTeamsRoutes(navigation),
        handle: {
          meta: () => ({
            title: i18n.t('calendar.team_view'),
          }),
        },
      },
      {
        path: navigation.calendar.bulkAddTimeOff.path,
        element: <BulkAddTimeOffModalPage />,
      },
    ],
  }),
])
